// Author YuJiaBei
// Create by manual
// Date 2020-05-14 13:14:36

import * as model from "@/model/em/repair/RepairWorkOrderExecuteModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.RepairWorkOrderExecute(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_REPAIR_URL,
        processBusinessData: Object,
        listPathType: String,
        taskPathType: String,
        editPathType: String
    })
    .buildStore()
